import useCustomization from './useCustomization';

export default function useUiConfig() {
  const customization = useCustomization();

  return customization?.fe_config;
}
